import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import {thunk as thunkMiddleware} from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import reducers from './reducers';

const persistConfig = {
  key: 'paymentSession',
  stateReconciler: autoMergeLevel2,
  storage,
  whitelist: ['payment', 'shop', 'invoice'],
};

const persistedReducers = persistReducer(persistConfig, reducers);

const middlewares = [thunkMiddleware];
const loggerMiddleware = createLogger();
if (process.env.REACT_APP_ENV !== 'production') {
  middlewares.push(loggerMiddleware);
}

const store = configureStore({
  reducer: persistedReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST'],
    },
  }).concat(middlewares),
});

export const persistor = persistStore(store);

export default store;
